<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="请输入单据号或备注" v-model="queryParam.kw"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单据日期">
              <a-range-picker @change="dateChange" :defaultValue="[moment(queryParam.s_date, format), moment(queryParam.e_date, format)]"></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="供应商"
            >
              <a-input-search
                placeholder="请选择供应商"
                @change="supplierTextChange"
                @search="onSupplierSearch"
                @click="onSupplierSearch"
                v-model="supplierName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      size="default"
      ref="table"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
      rowKey="id"
    >
      <span slot="billNo" slot-scope="text, record">
        <router-link :to="{ path: '/purchase/invoice/edit/'+record.id }">{{record.billNo}}</router-link>
      </span>
      <span slot="transType" slot-scope="text, record">
        {{ record.transType == 'purchase_invoice_in' ? '普通采购': '采购退回'}}
      </span>
      <span slot="totalAmount" slot-scope="text, record">
        {{ record.transType == 'purchase_invoice_in' ? record.totalAmount: '-'+record.totalAmount}}
      </span>
      <span slot="locked" slot-scope="text, record">
        <span style="color: red" v-if="record.locked <= 0">未支付</span>
        <span style="color: green" v-if="record.locked > 0">已支付</span>
      </span>
      <span slot="note" slot-scope="text, record">
        <div v-if="record.pay">
          <div>{{record.pay.date}}</div>
          <a-divider v-if="record.pay.note"></a-divider>
          <div>{{record.pay.note}}</div>
        </div>
      </span>
      <span slot="action" slot-scope="text, record" v-if="record.locked <= 0">
        <a @click="clickPayCofirm(record)">确认支付</a>
      </span>
    </s-table>
    <SupplierModal :visible="supplierModalVisible" @handleCancel="supplierModalCancel" @handleOk="supplierModalOk"></SupplierModal>
    <a-modal
      title="支付确认"
      style="top: 20px;"
      :width="600"
      v-model="payModal"
      @ok="savePay"
    >
      <a-form>
        <a-form-item
          label="付款日期"
          required
          :labelCol="{xs: { span: 24 },sm: { span: 6 }}"
          :wrapperCol="{xs: { span: 24 },sm: { span: 18 }}"
        >
          <a-date-picker v-model="invoiceData.date" :format="format"></a-date-picker>
        </a-form-item>

        <a-form-item
          :labelCol="{xs: { span: 24 },sm: { span: 6 }}"
          :wrapperCol="{xs: { span: 24 },sm: { span: 18 }}"
          label="备注"
        >
          <a-textarea v-model="invoiceData.note" placeholder="填写备注信息" :autosize="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>

      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import moment from 'moment'
import STable from '@/components/table/'
import SupplierModal from '@/components/Supplier/Modal'
import { getPayList, addPay } from '@/api/money'
import { CODE_FAIL } from '@/store/mutation-types'

export default {
  components: {
    STable,
    SupplierModal
  },
  data () {
    return {
      payModal: false,
      invoiceData: {
        billId: 0,
        date: moment(),
        note: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      supplierModalVisible: false,
      // 查询参数
      queryParam: {
        s_date: '',
        e_date: '',
        contactId: '',
        kw: ''
      },

      supplierName: '',
      // 表头
      columns: [
        {
          title: '单据日期',
          dataIndex: 'billDate',
          className: 'text-center'
        },
        {
          title: '订单编号',
          dataIndex: 'billNo',
          className: 'text-center',
          scopedSlots: { customRender: 'billNo' }
        },
        {
          title: '供应商',
          dataIndex: 'supplier.name',
          className: 'text-center'
        },
        {
          title: '业务类型',
          dataIndex: 'transType',
          className: 'text-center',
          scopedSlots: { customRender: 'transType' }
        },
        {
          title: '金额',
          className: 'text-right',
          dataIndex: 'totalAmount',
          scopedSlots: { customRender: 'totalAmount' }
        },
        {
          title: '支付状态',
          className: 'text-center',
          scopedSlots: { customRender: 'locked' }
        },
        {
          title: '支付时间/备注',
          dataIndex: 'note',
          className: 'text-center',
          scopedSlots: { customRender: 'note' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          className: 'text-center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getPayList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    this.queryParam.s_date = moment().subtract(7, 'days').format(this.format)
    this.queryParam.e_date = moment().format(this.format)
  },
  methods: {
    moment,
    supplierTextChange (e) {
      if (!e.data) {
        this.queryParam.contactId = ''
      }
    },
    supplierModalCancel () {
      this.supplierModalVisible = false
    },
    supplierModalOk (selectedRows) {
      this.supplierModalVisible = false
      if (selectedRows.length > 0) {
        const ids = []
        const names = []
        selectedRows.forEach(function (item) {
          ids.push(item.id)
          names.push(item.name)
        })
        this.queryParam.contactId = ids.join(',')
        this.supplierName = names.join(',')
      }
    },
    onSupplierSearch () {
      this.supplierModalVisible = true
    },
    dateChange (date, dateString) {
      this.queryParam.s_date = dateString[0]
      this.queryParam.e_date = dateString[1]
    },

    tableSearch () {
      this.$refs.table.refresh(true)
    },
    clickPayCofirm (record) {
      this.invoiceData.billId = record.id
      this.invoiceData.note = ''
      this.invoiceData.date = moment()
      this.payModal = true
    },
    savePay () {
      if (!this.invoiceData.date) {
        this.$message.error('请选择支付日期')
        return false
      }
      const savedata = { ...this.invoiceData }
      savedata.date = moment(this.invoiceData.date).format(this.format)
      addPay(savedata).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('确认成功')
          this.payModal = false
          this.tableSearch()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
</style>
